/* eslint-disable */
import {
  Button,
  Select,
  Flex,
  message,
  Image,
  Space,
  Form,
  Input,
  Modal,
  Steps,
  Radio,
  Spin,
} from "antd";
import React, { useEffect, useState, useRef } from "react";
import "@/common.css";
import { formatAmount } from "@/components/formatter";
import {
  ExclamationCircleFilled,
  ExclamationCircleOutlined,
  RotateLeftOutlined,
  SnippetsOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import { Card } from "antd";
import moment from "moment";
import "@/views/JobRequests/UserCompon.css";
import FormattedDate from "./component/FormattedDate";
import { useLocation } from "react-router-dom";
import commonFn from "@/utils/commonFn";
export default function Details() {
  const location = useLocation();
  const state = location.state || {};
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);
  const [form, form4] = Form.useForm();
  const [stepForm] = Form.useForm();
  const [VendorValue, setVendorValue] = useState(null);
  const [vendorId, setVendorId] = useState(null);
  const [vendorType, setVendorType] = useState(null);
  const [vendorTypeData, setvendorTypeData] = useState(0);
  const [vendorSelectValue, setVendorSelectValue] = useState(null);
  const [agreeStype, setAgreeStype] = useState(1);
  const [agree, setAgree] = useState(0);
  const [refuseReason, setRefuseReason] = useState(null);
  const [amountData, setAmountData] = useState(null);
  const [BtnLoading, setBtnLoading] = useState(false);
  const [stepUploadBtn, setStepUploadBtn] = useState(false);
  const [modalupload, setmodalupload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [VendorList, setVendorList] = useState([]);
  const [stepone, setdStepone] = useState([]);
  const [stepfour1, setdStepFour] = useState([]);
  const [service, setService] = useState(0);
  const [disabled, setDisabled] = useState(false);
  const [disabledOne, setDisabledOne] = useState(true);
  const [disabledAssginTo, setDisabledAssginTo] = useState(true);
  const [modal1Open, setModal1Open] = useState(false);
  const [BackModalOpen, setBackModalOpen] = useState(false);
  const [setpData, setSetpData] = useState(null);
  const [stepFourWait, setStepFourWait] = useState(false);
  const [stepFourInfo, setStepFourInfo] = useState(false);
  const [stepFiveWait, setStepFiveWait] = useState(false);
  const [stepFiveDetail, setStepFiveDetail] = useState(false);
  const [nowMainten, setNowMainten] = useState(null);
  const [stepFourDetail, setStepFourDetail] = useState(false);
  const [repairType, setRepairType] = useState(false);
  const [stepShow, setstepShow] = useState(0);
  const [showRollbackButton, setshowRollbackButton] = useState(false);
  const [stepLoading, setStepLoading] = useState(false);
  const [setpDataOne, setSetpDataOne] = useState({
    maintenanceId: null,
    processId: null,
    files: [],
  });
  //初始化数据
  const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 16,
    },
  };

  const [descrItems, setdDescrItems] = useState([
    {
      key: "1",
      label: "Remark",
      children: "这是一条备注信息",
    },
  ]);

  //表单规则
  const validateMessages = {
    required: "${label} is required!",
    types: {
      email: "${label} is not a valid email!",
      number: "${label} is not a valid number!",
    },
    number: {
      range: "${label} must be between ${min} and ${max}",
    },
  };

  // 监听表单值变化
  const onValuesChange = (changedValues, allValues) => {
    if ("amount" in changedValues) {
      setAmountData(changedValues.amount); // 更新 amountData
    }
  };

  const setProcess = async () => {
    setdDescrItems((prevItems) => {
      // 复制原数组并更新指定元素
      const updatedItems = prevItems.map((item, index) => {
        if (index === 0) {
          // 定位到要更新的元素（索引为2）
          return {
            ...item,
            key: `key-${Date.now()}`, // 更新 key
            children: state.remark ? state.remark : "暂无", // 更新值
          };
        }
        return item; // 其他元素保持不变
      });
      return updatedItems; // 返回更新后的数组
    });
  };

  const stepSearchChange = (value) => {
    vendorFun(value);
  };
  const payChange = (e) => {
    const selectedValue = e.target.value;
    console.log(selectedValue);
    setVendorSelectValue(selectedValue);
    setvendorTypeData(selectedValue);
    setVendorList([]); 
    setVendorValue(null);
  };
  //获取vendor列表
  const vendorFun = async (content, showId, selectedValue) => {
    try {
      let url = `${api.vendorType}?content=${encodeURIComponent(content || "")}`;

      if (vendorSelectValue === 1) {
        url += "&vendorType=Maintenance";
      } else if (vendorSelectValue === 2) {
        url += "&vendorType=Contractor";
      }
      const response = await http.get(url);
      if (response && response.data) {
        const formattedData = response.data.map((item) => ({
          value: Number(item.vendorId),
          label: item.vendorName,
          id: item.vendid,
          vendorName: item.vendorName,
        }));
        setVendorList(formattedData);
        //console.log(formattedData)
      }
    } catch (err) {
      setError(err);
    } finally {
      //setBtnLoading(false)  // 设置加载状态
    }
  };
  const agreeChange = (e) => {
    console.log("radio checked", e.target.value);
    if (e.target.value === "1") setRefuseReason("");
    setAgree(e.target.value);
  };

  const stepChange = (value, option) => {
    console.log("stepChange", value);
    console.log("stepChange", option);
    setVendorValue(option.label); // 设置默认值
    setVendorId(option.value);
    stepForm.setFieldsValue({
      VendorValue: option.label,
      vendorId: option.value,
      // vendorId: option.id,
    }); // 设置表单字段的值
  };

  //表单form1提交
  const stepFinish = (values) => {
    stepThree(values);
  };
  const agreeConfirm = (stype) => {
    setModal1Open(true);
    setAgreeStype(stype);
  };

  const { confirm } = Modal;
  //选择维修和不维修
  const serviceChange = (e) => {
    console.log("radio checked", e.target.value);
    confirm({
      title:
        e.target.value === 1
          ? "Are you sure you want to choose Repair?"
          : "Are you sure you want to choose Document Only?",
      icon: <ExclamationCircleFilled />,
      content: "",
      centered: true, // 设置居中显示
      onOk() {
        setService(e.target.value);
        if (e.target.value === 1) setstepShow(2);
        setDisabled(true);
        stepTwo(e.target.value);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const setpFourDoc = () => {
    const baseFields = [
      setpData?.four?.vendorAmount != null && {
        title: "Amount:",
        value: (
            <span>{formatAmount(setpData.four.vendorAmount)}</span>
   
        ),
      },
      {
        title: "Predict CompletionTime:",        value:
          setpData?.four?.predictCompletionTime &&
          moment(setpData.four.predictCompletionTime).format("MM/DD/YYYY "),
      },
      {
        title: "Repair Remark:",
        value: setpData?.four?.repairRemark ? setpData.four.repairRemark : "",
      },
      {
        title: "Need Material:",
        value:
          (setpData?.four?.isMaterials &&
            (setpData.four.isMaterials === 1
              ? "Yes"
              : setpData.four.isMaterials === 2
              ? "No"
              : "")) ||
          "",
      },
    ];

    const materialFields =
      setpData?.four?.isMaterials !== 2
        ? [
            {
              title: "Materials Remark:",
              value: setpData?.four?.materialsRemark || "",
            },
            {
              title: "Pick-Up Location:",
              value: setpData?.four?.storeName || "",
            },
            {
              title: "Materials Confirm Type:",
              value:
                (setpData?.four?.materialsConfirmType &&
                  (setpData.four.materialsConfirmType === 1
                    ? "agree"
                    : "no Agree")) ||
                "",
            },
          ]
        : [];
    // 不需要材料 isMaterials为2时候 隐藏下面3个字段的显示。
    const docList = [...baseFields, ...materialFields];
    return (
      <>
        {docList.map((item) => (
          <div className="detail_line">
            <span className="detail_title">
              <strong>{item.title}&nbsp;</strong>
            </span>
            <span>{item.value}</span>
          </div>
        ))}
      </>
    );
  };

  //查看工单流程
  const setpFun = async (id) => {
     setStepLoading(true);
    try {
      const response = await http.get(`${api.process}?id=${id}`);
      setSetpData(response.data);
      // console.log("setSetpData-------->", response.data);
      if (response.data.rollbackButton === 1) {
        setshowRollbackButton(true);
      } else if (response.data.rollbackButton === 2) {
        setshowRollbackButton(false);
      }
      if (response.data.one.processComplete === 1) {
        console.log("======步骤1完成");
        setDisabledOne(false);
        //processComplete:1完成 2为未完成
        // console.log("setpData--->", setpData);
        setstepShow(1); //步骤1完成
        setDisabled(false); //回退到第一步时候 第二步的repair  disabled重置
        setService(0);
        const DataOne = {
          ...setpDataOne,
          maintenanceId: id,
          processId: response.data.one.id,
        };
        setSetpDataOne(DataOne);

        setdStepone(response.data.one.maintenanceFiles);
        if (response.data.two.processComplete === 1) {
          //步骤2完成
          console.log("执行了1");
          setstepShow(2);
          setDisabled(true);
          console.log("第二部步选择器", response.data.two.repairType);
          setRepairType(response.data.two.repairType); //1维修2不维修
          if (response.data.two.repairType === 1) setService(1);
          else setService(2);
        }
        if (
          response.data.two.processComplete === 1 &&
          response.data.two.repairType === 1
        ) {
          //步骤2选择了维修
          console.log("执行了2");
          stepForm.resetFields();
          // vendorFun("");
          // 暂时放这里
        }
        if (response.data.three.processComplete === 1) {
          //步骤3完成(1完成2未完成)
          setstepShow(3);
          // vendorFun("", response.data.three.vendorId);
          //setVendorType(response.data.three.processComplete)
        }
        if (response.data.three.processComplete === 1 && !response.data.four) {
          //等待vender提交信息
          setStepFourWait(true);
          console.log("等待vender提交信息");
        } else {
          setStepFourWait(false);
        }

        if (
          response.data.three.processComplete === 1 &&
          response.data.four.processComplete === 2
        ) {
          //vender已经提交信息
          console.log("vender已经提交信息");
          setStepFourDetail(true);
          setStepFourInfo(true);
        }
        if (response.data.four.processComplete === 1) {
          setStepFourInfo(true);
          setStepFourDetail(false);
          setstepShow(4);
          setdStepFour(response.data.four.maintenanceFiles);
        }

        if (response.data.four.processComplete === 1 && !response.data.five) {
          setStepFiveWait(true);
        } else if (
          response.data.four.processComplete === 1 &&
          response.data.five.processComplete === 2
        ) {
          setStepFiveWait(false);
          setStepFiveDetail(true);
        } else if (response.data.five.processComplete === 1) {
          setstepShow(5);
          setStepFiveDetail(false);
        }
      } else if (response.data.one.processComplete === 2) {
        console.log("======步骤1未完成");
        const DataOne = {
          ...setpDataOne,
          maintenanceId: id,
          processId: response.data.one.id,
        };
        console.log(DataOne);
        setSetpDataOne(DataOne);
        setstepShow(0);
        setDisabled(true);
      }

      console.log(response);
      console.log(descrItems);
    } catch (err) {
      setError(err); // 捕获错误
    }  finally {
    setStepLoading(false); 
  }
  };

  //步骤
  const stepsItems = [
    {
      title: (
        <Flex justify="flex-start" align="flex-start">
          <Space size="small">
            <div>
              <strong>Request Content</strong>
            </div>
            {stepShow > 0 ? (
              <Space>
                <span className="stepHead">
                  {setpData.one ? setpData.one.createByName : ""}
                  &nbsp;&nbsp;&nbsp;
                  {setpData.one
                    ? moment(setpData.one.endTime).format("MM/DD/YYYY HH:mm")
                    : ""}
                  &nbsp;&nbsp;&nbsp; Request By : &nbsp;
                  {nowMainten.createByType == 1
                    ? "Tenant"
                    : nowMainten.createByType == 2
                    ? "Manager"
                    : ""}
                  &nbsp;&nbsp;&nbsp;
                </span>
              </Space>
            ) : (
              <div></div>
            )}
          </Space>
        </Flex>
      ),
      hidden: false,
      description:
        stepShow === 0 ? (
          <Card  style={{ minWidth: 300 }}>
            {/* 步骤1 */}
          </Card>
        ) : (
          <Card loading={loading} style={{ minWidth: 300 }}>
            <Flex justify="flex-start" align="flex-start">
              <Space size="small">
                {stepone.map((item, index) => (
                  <Image
                    key={index}
                    width={100}
                    height={100}
                    style={{ objectFit: "cover" }}
                    src={item.url}
                  />
                ))}
              </Space>
            </Flex>
            <div>
                  <div className="detail_line">
                <span className="detail_title">
                  {" "}
                  <strong>Request Number：</strong>{" "}
                </span>
                <span>
                  {setpData.one ? setpData.one.requestNo :"No Data"}
                </span>
              </div>
              <div className="detail_line">
                <span className="detail_title">
                  {" "}
                  <strong>Prop-unit:</strong>{" "}
                </span>
                <span>
                  {nowMainten
                    ? nowMainten.propUnit + "-" + nowMainten.address
                    : "No Data"}
                </span>
              </div>
              <div className="detail_line">
                <span className="detail_title">
                  <strong>City:&nbsp;</strong>
                </span>
                <span>{nowMainten ? nowMainten.city : "No Data"}</span>
              </div>
              <div className="detail_line">
                <span className="detail_title">
                  <strong>Jobs:&nbsp;</strong>
                </span>
                <span>{nowMainten ? nowMainten.job : "No Data"}</span>
              </div>

              <div className="detail_line_title">
                <span className="detail_title">
                  <strong>Remark:&nbsp;</strong>
                </span>
                <span className="detail_text">
                  {nowMainten ? nowMainten.remark : "No Data"}
                </span>
              </div>

              {/* <div className='detail_line'>
                <span className='detail_title'><strong>Address:</strong>  </span>
                <span>{nowMainten ? nowMainten.address : 'No Data'}</span>
              </div> */}
            </div>
          </Card>
        ),
    },
    {
      title: (
        <Flex justify="flex-start" align="flex-start">
          <Space size="small">
            <div>
              <strong>Repair Decision</strong>
            </div>
            {stepShow > 1 ? (
              <Space>
                <span className="stepHead">
                  {setpData.two ? setpData.two.createByName : ""}
                  &nbsp;&nbsp;&nbsp;
                  {setpData.two
                    ? moment(setpData.two.endTime).format("MM/DD/YYYY HH:mm")
                    : ""}
                </span>
              </Space>
            ) : (
              <div></div>
            )}
          </Space>
        </Flex>
      ),
      hidden: false,
      description: (
        <Card
          style={{
            minWidth: 300,
          }}
        >
          <Flex justify="flex-start" align="flex-start">
            <Space size="large">
              <Radio.Group
                onChange={serviceChange}
                value={service}
                disabled={disabled}
              >
                <Radio value={1}>
                  <strong>Repair</strong>
                </Radio>
                <Radio value={2}>
                  <strong>Document Only</strong>
                </Radio>
              </Radio.Group>
            </Space>
          </Flex>
        </Card>
      ),
    },
    {
      title: (
        <Flex justify="flex-start" align="flex-start">
          <Space size="small">
            <div>
              <strong>Assign To</strong>
            </div>
            {stepShow > 2 ? (
              <Space>
                <span className="stepHead">
                  {setpData.three ? setpData.three.createByName : ""}
                  &nbsp;&nbsp;&nbsp;
                  {setpData.three
                    ? moment(setpData.three.endTime).format("MM/DD/YYYY HH:mm")
                    : ""}
                </span>
              </Space>
            ) : (
              <div></div>
            )}
          </Space>
        </Flex>
      ),
      hidden: false,
      description: (
        <Card style={{ minWidth: 300 }}>
          {stepShow > 2 && (
            <div>
              <div className="detail_line">
                <span className="detail_title">
                  <strong>Vendor Type:&nbsp;</strong>
                </span>
                <span>
                  {setpData.three.vendorType === 2
                    ? "Contractor(PO)"
                    : "Monthly Maintenance"}
                </span>
              </div>
              <div className="detail_line">
                <span className="detail_title">
                  <strong>Selected Vendor:&nbsp;</strong>
                </span>
                <span>{setpData.three.vendorName}</span>
              </div>

              {setpData?.three?.vendorAmount ?? "" ? (
                <div className="detail_line">
                  <span className="detail_title">
                    <strong>Quotation:&nbsp;</strong>
                  </span>
                  <span>{formatAmount(setpData.three.vendorAmount)}</span>
                </div>
              ) : null}
              <div className="detail_line">
                <span className="detail_title">
                  <strong>Email Vendor:&nbsp;</strong>
                </span>
                <span>{setpData.three.sendEmail === 2 ? "No" : "Yes"}</span>  <span>{setpData.three.toEmail}</span>
              </div>
            </div>
          )}
          {/* (stepShow !== 2 &&
            stepShow !== 3 &&
            stepShow !== 4 &&
            stepShow !== 5) || */}
          {setpData && setpData.two && setpData.two.repairType === 2 && (
            <Form form={form} name="myForm" layout="vertical">
              <Form.Item
                name="vendorType"
                label="Type"
                rules={[{ required: true }]}
              >
                <Radio.Group
                  onChange={payChange}
                  value={vendorSelectValue}
                  disabled={disabledAssginTo}
                >
                  {" "}
                  <Radio value={1}>Monthly Maintenance</Radio>
                  <Radio value={2}>Contractor(PO)</Radio>
                </Radio.Group>
              </Form.Item>
            </Form>
          )}
          {setpData &&
            setpData.two &&
            setpData.two.repairType === 1 &&
            !setpData.three && (
              <Form
                {...layout}
                onFinish={stepFinish}
                form={stepForm}
                validateMessages={validateMessages}
                onValuesChange={onValuesChange}
                labelCol={{ span: 5 }}
                wrapperCol={{ span: 19 }}
              >
                {stepShow === 2 && (
                  <Form.Item
                    name="vendorType"
                    label="Type"
                    rules={[{ required: true }]}
                  >
                    <Radio.Group onChange={payChange} value={vendorType}>
                      <Radio value={1}>Monthly Maintenance</Radio>
                      <Radio value={2}>Contractor(PO)</Radio>
                    </Radio.Group>
                  </Form.Item>
                )}
                {(vendorTypeData === 1 || vendorTypeData === 2) && (
                  <Form.Item
                    name="VendorValue"
                    label="Vendor"
                    rules={[{ required: true }]}
                  >
                    <Select
                      showSearch
                      allowClear
                      onChange={stepChange}
                      onSearch={stepSearchChange}
                      placeholder="Select Vendor"
                      optionFilterProp="label"
                      value={VendorValue}
                      filterOption={false}
                      options={VendorList}
                      // optionLabelProp="label"
                      optionRender={(option) => (
                        <Space>
                          <span role="img" aria-label={option.data.vendorName}>
                            {option.data.vendorName}
                          </span>
                        </Space>
                      )}
                    />
                  </Form.Item>
                )}
                {vendorTypeData === 2 && (
                  <Form.Item
                    name="amount"
                    label="Amount"
                    rules={[
                      { required: true, message: "Please input the amount!" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                )}
                {(vendorTypeData === 1 || vendorTypeData === 2) && (
                  // {(vendorType === 1 || vendorType === 2) && (
                  <Form.Item
                    name="sendEmail"
                    label="Email Vendor"
                    rules={[{ required: true }]}
                  >
                    <Radio.Group value={"1"}>
                      <Radio value={2}>No</Radio>
                      <Radio value={1}>Yes</Radio>
                    </Radio.Group>
                  </Form.Item>
                )}
                {(vendorTypeData === 1 || vendorTypeData === 2) &&
                  stepShow !== 3 && (
                    <Form.Item className="btnCenter">
                      <Button type="primary" htmlType="submit">
                        Submit
                      </Button>
                    </Form.Item>
                  )}
              </Form>
            )}
        </Card>
      ),
    },
    {
      title: (
        <Flex justify="flex-start" align="flex-start">
          <Space size="small">
            <div>
              <strong>Approval Status</strong>
            </div>
            {stepShow > 3 ? (
              <Space>
                <span className="stepHead">
                  {setpData.four ? setpData.four.createByName : ""}
                  &nbsp;&nbsp;&nbsp;
                  {setpData.four
                    ? moment(setpData.four.endTime).format("MM/DD/YYYY HH:mm")
                    : ""}
                </span>
                {/* <Text code>(createBy:{setpData.two.createBy?setpData.two.createBy:'暂无'} , endTime:{setpData.two.endTime?setpData.two.endTime:'暂无'})</Text> */}
              </Space>
            ) : (
              <div></div>
            )}
          </Space>
        </Flex>
      ),
      hidden: false,
      description: (
        <Card style={{ minWidth: 300 }}>
          {setpData &&
            setpData.three &&
            setpData.three.processComplete === 1 &&
            !setpData.four && (
              <>
                {setpFourDoc()}
                <div className="flexStart colYe">
                  <ExclamationCircleOutlined className="iconYe" />
                  <div>Waiting For Repair Outcome</div>
                </div>
              </>
            )}
          {/*stepShow < 3  */}
          {/* {setpData && setpData.four && setpData.four.processComplete !== 1 ? (
            <Button type="primary" disabled>
              examine
            </Button>
          ) : (
            <div></div>
          )} */}
          {((setpData &&
            setpData.four &&
            setpData.four.processComplete === 1) ||
            (setpData &&
              setpData.four &&
              setpData.four.processComplete === 2)) && (
            <div>
              <Flex justify="flex-start" align="flex-start">
                <Space size="small">
                  {setpData?.four?.maintenanceFiles?.map((file) => (
                    <Image
                      key={file.id}
                      width={100}
                      height={100}
                      style={{ objectFit: "cover", padding: "10px" }}
                      src={file.url}
                      alt={file.fileName}
                    />
                  ))}
                </Space>
              </Flex>
              {setpFourDoc()}
              {/* 新增第四步拒绝原因 */}
              <div>
                {setpData?.four &&
                  setpData?.four?.materialsConfirmType === 2 && (
                    <div className="detail_line">
                      <span
                        className="detail_title"
                        style={{ color: "#d1102b" }}
                      >
                        <strong>Refuse Reason:&nbsp;</strong>
                      </span>
                      <span style={{ color: "#d1102b" }}>
                        {(setpData.four &&
                          setpData.four.refuseMaterialsRemark) ||
                          ""}
                      </span>
                    </div>
                  )}
              </div>
              <div>
                {setpData?.four && setpData?.four?.processComplete === 1 && (
                  <div className="detail_line">
                    <span className="detail_title" style={{ color: "#17ae0c" }}>
                      <CheckCircleOutlined />
                    </span>
                    <span style={{ color: "#17ae0c", marginLeft: "10px" }}>
                      {setpData.four && setpData.four.fourApproveRemark
                        ? setpData.four.fourApproveRemark
                        : " "}
                    </span>
                  </div>
                )}
              </div>

              {/* <span>{setpData.four&&setpData.four.storeName ? setpData.four.storeName : 'no Data'}</span> */}

              {stepFourDetail && setpData?.four?.materialsConfirmType !== 2 && (
                <div>
                  <Button type="primary" onClick={() => agreeConfirm(1)}>
                    Examine
                  </Button>
                </div>
              )}
            </div>
          )}
        </Card>
      ),
    },
    ,
    {
      title: (
        <Flex justify="flex-start" align="flex-start">
          <Space size="small">
            <div>
              <strong>Repair Outcome</strong>
            </div>
            {stepShow > 4 ? (
              <Space>
                <span className="stepHead">
                  {setpData.five ? setpData.five.createByName : ""}
                  &nbsp;&nbsp;&nbsp;
                  {setpData.five
                    ? moment(setpData.five.endTime).format("MM/DD/YYYY HH:mm")
                    : ""}
                </span>
              </Space>
            ) : (
              <div></div>
            )}
          </Space>
        </Flex>
      ),
      hidden: false,
      description: (
        <Card style={{ minWidth: 300 }}>
          {/* {stepShow < 4 && (
                  <Button type="primary" disabled>examine</Button>
                )} */}
          {/* {stepFiveWait ? ( */}
          {setpData &&
            setpData.four &&
            setpData.four.processComplete === 1 &&
            !setpData.five && (
              <div className="flexStart colYe">
                <ExclamationCircleOutlined className="iconYe" />
                <div>Waiting For Repair Outcome</div>
              </div>
            )}
          {((setpData &&
            setpData.four &&
            setpData.four.processComplete === 2) ||
            (setpData &&
              setpData.five &&
              setpData.five.processComplete === 1) ||
            (setpData &&
              setpData.four &&
              setpData.four.processComplete === 1 &&
              setpData &&
              setpData.five &&
              setpData.five.processComplete === 2)) && (
            <div>
              <Flex justify="flex-start" align="flex-start">
                <Space size="small">
                  {setpData?.five?.maintenanceFilesByDate &&
                    Object.entries(setpData?.five?.maintenanceFilesByDate).map(
                      ([date, files]) => (
                        <div key={date}>
                          <div style={{ display: "flex" }}>
                            <span>Photo Uploaded On:&nbsp; </span>{" "}
                            <FormattedDate dateString={date} />
                          </div>
                          {files.map((file) => (
                            <Image
                              key={file.id}
                              width={100}
                              height={100}
                              style={{ objectFit: "cover", padding: "10px" }}
                              src={file.url}
                            />
                          ))}
                        </div>
                      )
                    )}
                </Space>
              </Flex>

              <div className="detail_line">
                {setpData?.five?.tenantConfirmFiles &&
                setpData?.five?.tenantConfirmFiles.length > 0 ? (
                  <div>
                    <span className="detail_title">
                      {" "}
                      <strong>Job Accepted By:</strong>
                    </span>
                    <span>
                      {setpData?.five && setpData?.five.tenantConfirmName
                        ? setpData?.five.tenantConfirmName
                        : ""}
                    </span>,<span> {setpData?.five && setpData?.five.tenantConfirmTime
                    ? moment(setpData.five.tenantConfirmTime).format("MM/DD/YYYY HH:mm")
                    : ""}
                    </span>
                    <Flex justify="flex-start" align="flex-start">
                      <Space size="small">
                        <Image
                          width={100}
                          height={100}
                          style={{ objectFit: "cover" }}
                          src={
                            setpData?.five?.tenantConfirmFiles &&
                            setpData?.five?.tenantConfirmFiles[0].url
                          }
                        />
                      </Space>
                    </Flex>
                  </div>
                ) : null}
              </div>
              <div>
                {setpData?.five &&
                  setpData?.five?.repairCompleteConfirmType === 2 && (
                    <div className="detail_line">
                      <span
                        className="detail_title"
                        style={{ color: "#d1102b" }}
                      >
                        <strong>Refuse Reason:&nbsp;</strong>
                      </span>
                      <span style={{ color: "#d1102b" }}>
                        {setpData.five && setpData.five.refuseRemark
                          ? setpData.five.refuseRemark
                          : " "}
                      </span>
                    </div>
                  )}
              </div>
              <div>
                {setpData?.five &&
                  setpData?.five?.repairCompleteConfirmType === 1 && (
                    <div className="detail_line">
                      <span
                        className="detail_title"
                        style={{ color: "#17ae0c" }}
                      >
                        <CheckCircleOutlined />
                      </span>
                      <span style={{ color: "#17ae0c", marginLeft: "10px" }}>
                        {setpData.five && setpData.five.fiveApproveRemark
                          ? setpData.five.fiveApproveRemark
                          : " "}
                      </span>
                    </div>
                  )}
              </div>
            </div>
          )}

          {/* {setpData && setpData.five && setpData.five.repairCompleteType === 1 && ( */}
          {/* {setpData && setpData.five && setpData.five.processComplete === 1 && ( */}
          {setpData &&
          setpData.five &&
          setpData.five.repairCompleteType === 1 &&
          setpData.five.processComplete !== 1 &&
          setpData?.five?.repairCompleteConfirmType !== 2 ? (
            <div className="mt10">
              <Button type="primary" onClick={() => agreeConfirm(2)}>
                examine
              </Button>
            </div>
          ) : null}
        </Card>
      ),
    },
  ];

  //工单流程第二步:选择是否维修
  const stepTwo = async (repairType) => {
    console.log(descrItems);
    console.log(localStorage);
    console.log(localStorage.getItem("createBy"));
    console.log("setpDataOne", setpDataOne);
    const stepTwoData = {
      repairType: repairType,
      maintenanceId: setpDataOne.maintenanceId,
      processType: 2,
      createBy: localStorage.getItem("accountId"),
      //  "createBy":'766',
    };
    console.log("---------222222-------------", stepTwoData);
    try {
      const response = await http.post(`${api.addTo2}`, stepTwoData);
      if (response.code === "1") {
        const messageContent =
          repairType === 1 ? "Selected Repair" : "Selected Document Only";
        message.success(messageContent);
        setstepShow(2); //步骤走到2
        setpFun(setpDataOne.maintenanceId);
        setDisabledAssginTo(false);
      }
    } catch (err) {
      setError(err); // 捕获错误
    } finally {
      setStepUploadBtn(false); // 设置加载状态
    }
  };
  //工单流程第三步:选择维修人员
  const stepThree = async (data) => {
    console.log(descrItems);
    console.log(data);
    const stepTwoData = {
      maintenanceId: setpDataOne.maintenanceId,
      processType: 3,
      createBy: localStorage.getItem("accountId"),
      vendorType: data.vendorType,
      vendorId: vendorId,
      sendEmail: data.sendEmail,
      vendorAmount: amountData,
    };

    try {
      const response = await http.post(`${api.addTo3}`, stepTwoData);
      console.log(response);
      if (response.code === "1") {
        setpFun(setpDataOne.maintenanceId);
        // setstepShow(3)
      }else {
              commonFn.modalFailedFn(response)
            }
    } catch (err) {
      setError(err); // 捕获错误
    } finally {
      setStepUploadBtn(false); // 设置加载状态
    }
  };
  // 工单流程第四步  查看维修人员的照片
  const stepfour = async (item) => {
    console.log(setpDataOne.maintenanceId);
    console.log(setpData.four.id);
    console.log(refuseReason);
    let nowData = {
      id: setpData.four.id,
      maintenanceId: setpDataOne.maintenanceId,
      createBy: localStorage.getItem("accountId"),
      // createBy: '766',
      materialsConfirmType: Number(item.selection),
      refuseMaterialsRemark: item.reason ? item.reason : "",
    };
    console.log(nowData);
    try {
      const response = await http.post(`${api.updateTo4}`, nowData);
      if (response.code === "1") {
        console.log(response);
        setOpen(false);
        message.success("Successfully Added");
        setpFun(setpDataOne.maintenanceId);
        setmodalupload(false);
        // setstepShow(4)//步骤4完成
        setDisabled(false);
        setService(0);
      } else {
        Modal.confirm({
          title: "Error:",
          // icon: <ExclamationCircleOutlined />,
          content: response.msg,
          footer: null,
          closable: true,
          maskClosable: true,
        });
      }
    } catch (err) {
      setError(err); // 捕获错误
    } finally {
      setStepUploadBtn(false); // 设置加载状态
    }
  };
  // 工单流程第五步:确认维修后的效果
  const stepfive = async (item) => {
    console.log(setpDataOne.maintenanceId);
    console.log(setpData.four.id);
    console.log(refuseReason);
    let nowData = {
      id: setpData.five.id,
      maintenanceId: setpDataOne.maintenanceId,
      createBy: localStorage.getItem("accountId"),
      // createBy: '766',
      repairCompleteConfirmType: Number(item.selection),
      refuseRemark: item.reason ? item.reason : "",
    };
    console.log(nowData);

    try {
      const response = await http.post(`${api.updateTo5}`, nowData);
      console.log(response);
      setOpen(false);
      message.success("Successfully Added");
      setpFun(setpDataOne.maintenanceId);
      setmodalupload(false);
      // setstepShow(4)//步骤4完成
      setDisabled(false);
      setService(0);
    } catch (err) {
      setError(err); // 捕获错误
    } finally {
      setStepUploadBtn(false); // 设置加载状态
    }
  };

  //  表单提交
  const agreeSubmit = (values) => {
    console.log("Form Values:", values);
    if (agreeStype === 1) {
      //步骤四
      setModal1Open(false);
      stepfour(values);
    } else {
      //步骤五
      setModal1Open(false);
      stepfive(values);
    }
  };
  // 回退
  const handleCancel = () => {
    setBackModalOpen(false);
    console.log("Cancel");
  };
  const handleBalcOk = async () => {
    try {
      const response = await http.get(
        `${api.rollbackProcess}?maintenanceId=${nowMainten.id}`
      );
      if (response.code == 1) {
        setBackModalOpen(false);
        message.success("Successfully!");
        setpFun(setpDataOne.maintenanceId);
      }
    } catch (err) {
      setError(err); // 捕获错误
    } finally {
  
    }
  };

  // 使用 useEffect 在页面加载时执行方法
  useEffect(() => {
    setTimeout(() => {
      let params = {};
      const searchParams = new URLSearchParams(window.location.search);
      params = Object.fromEntries(searchParams.entries());
      if (Object.keys(params).length === 0) {
        const hash = window.location.hash.slice(1);
        const [route, queryString] = hash.split("?");
        if (queryString) {
          params = Object.fromEntries(
            new URLSearchParams(queryString).entries()
          );
        }
      }
      console.log("setNowMainten:", params);
      setNowMainten(params);
      setpFun(params.maintenanceId);
      setProcess();
    }, 1000); // 延迟2秒
  }, []); // 依赖数组为空，确保只在组件首次加载时执行
  useEffect(() => {
    const initializeFromParams = async () => {
      try {
        await new Promise((resolve) => setTimeout(resolve, 1000)); // Simulate a delay
        const params = new URLSearchParams(window.location.search);
        const vendorTypeParam = params.get("vendorType");

        if (vendorTypeParam) {
          const parsedVendorType = parseInt(vendorTypeParam, 10);
          if ([1, 2].includes(parsedVendorType)) {
            setVendorSelectValue(parsedVendorType);
          }
        }
      } catch (error) {
        console.error("Error initializing from params:", error);
      }
    };

    initializeFromParams();
  }, []);

useEffect(() => {
  if (vendorSelectValue !== null) {
    vendorFun(vendorSelectValue);
    form.setFieldsValue({
      vendorType: vendorSelectValue,
    });
  }
}, [vendorSelectValue, form]);
  return (
    <div>
      <div className="orderMain">
        <div
          style={{
            marginTop: "16px",
            fontWeight: "bold",
            fontSize: "20px",
            borderBottom: "5px solid #3c8dbc",
            lineHeight: "50px",
          }}
        >
          <SnippetsOutlined style={{ marginRight: "8px" }} />
          Viewing Job Progress
        </div>
  
        <div className="stepMain">
  <Spin
    spinning={stepLoading}
    tip="Loading..."
    size="large"
  >
    <Steps
      direction="vertical"
      current={stepShow}
      labelPlacement="vertical"
      items={stepsItems.filter((step) => !step.hidden)}
    />
  </Spin>
</div>
        {/* </Modal> */}

        {/* 是否同意 */}
        <Modal
          title="Do you agree?"
          style={{
            top: 20,
          }}
          footer={null} // 自定义 Footer
          centered
          open={modal1Open}
          onCancel={() => setModal1Open(false)}
            width="30%"
        >
          <Form
            labelCol={{
              span: 5,
            }}
            wrapperCol={{
              span: 13,
            }}
            form={form4} // 绑定表单实例
            validateMessages={validateMessages}
            layout="horizontal"
            onFinish={agreeSubmit} // 表单提交逻辑
                style={{
              maxWidth: 600,
              margin: "0 auto",
            }}
          >
            <Form.Item
              label="Select"
              name="selection" // 必须添加 name 属性
              rules={[
                {
                  required: true,
                  message: "Please select an option!",
                },
              ]}
            >
              <Radio.Group onChange={agreeChange}>
                <Radio value="1">Agree</Radio>
                <Radio value="2">Refuse</Radio>
              </Radio.Group>
            </Form.Item>
            {agree === "2" && (
              <Form.Item
                label="Refuse Reason "
                name="reason"
                rules={[
                  {
                    required: true,
                    message: "Please provide a reason!",
                  },
                ]}
              >
                 <Input
                               value={refuseReason}
                               style={{
                                 marginLeft: "10px",
                                 width: "400px",
                                 maxWidth: "100%",
                               }}
                             />
              </Form.Item>
            )}
            <Form.Item className="btnCenter">
              <Space align="center" size="large">
                <Button
                  key="back"
                  onClick={() => setModal1Open(false)}
                  size="large"
                >
                  Cancel
                </Button>
                <Button
                  type="primary"
                  htmlType="submit" // 使用 submit 触发表单验证和提交
                  loading={BtnLoading}
                  size="large"
                >
                  Submit
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Modal>

        {/* 是否回退弹窗 */}
        {/* 是否同意 */}

        <Modal
          title="Are you sure step back?"
          open={BackModalOpen}
          onOk={handleBalcOk}
          onCancel={handleCancel}
          centered
          icon={<ExclamationCircleFilled />}
        ></Modal>

        {showRollbackButton && (
          <Button
            onClick={() => setBackModalOpen(true)}
            icon={<RotateLeftOutlined />}
            type="primary"
            size="large"
            style={{
              position: "fixed",
              top: "50px",
              right: "30px",
              zIndex: 1000,
            }}
          >
            step back
          </Button>
        )}
      </div>
    </div>
  );
}
